import m from "mithril";

import {
	defineWidget, CardieWidget, InputWidget, Empty, ButtonNew, Notification, NoticeWidget
} from "@nebularstreams/libmui"

import MAINSTATE from "../State";
import {authLogin} from "../Api";

///////////////////////////////////////////////////////////////////////////

const

	// Auth Screen: Strings

	STR = {
		LOGIN1: "LOGIN",
		LOGIN2: "Enter your credentials to use nanostream studio",
		LOGIN3: "Login >",
		EMAIL: "email",
		PASSWORD: "password",
		TOC1: "By logging in you accept our",
		TOC2: "Terms And Conditions",
		LINK_TOC: "https://nanocosmos.de/terms",
		CREDENTIALS: "Please enter your credentials",
		ACCOUNT1: "Don't have an account ? ",
		LINK_SIGNUP: "https://dashboard.nanostream.cloud/signup",
		ACCOUNT2: "Having trouble? Don't worry, we're here to help!",
		ACCOUNT3: "If you encounter any issues, feel free to reach out to us via our",
		LINK_CONTACT: "https://nanocosmos.de/contact",
		ACCOUNT4: "Contact Form",
		ACCOUNT5: "Sign Up",
		IMAGE_PROMO: "https://dashboard.nanostream.cloud/assets/realtime-video-CDgYsowj.png"
	};

///////////////////////////////////////////////////////////////////////////

function isValid(loginState) {
	return loginState.email.length > 5 && loginState.email.indexOf("@") > 0 && loginState.password.length > 4;
}

async function auth(clientState) {

	clientState.busy = true;
	m.redraw();

	await authLogin(LOGINSTATE.email, LOGINSTATE.password);
	clientState.busy = false;
	m.redraw();

	if (MAINSTATE.organization)
		m.route.set(`/${MAINSTATE.organization}`);
}

const

	LOGINSTATE = {
		email: "",
		password: ""
	},

	// widget: Main Screen
	AuthScreen = defineWidget(
		({state}) => m(".flexcol.h-100.ohidden.grows.scrolly.outercontent",
			m(".flexrow.nowrap.grows.noshrink.innercontent", [
				m(".flexcol.grows.w-50.place-content-center",
					state.busy
						? [
							m(Empty, {
								icon: "sync.fa-spin",
								size: 2
							})
						]
						: [
							m(CardieWidget,
								{
									class: "login",
									nofold: true,
									element: "div",
									cols: true,
									bodyClass: "gap-1"
								},
								[
									m("h1", STR.LOGIN1),
									m("h4", STR.LOGIN2),
									m(InputWidget, {
										containerClass: "w-100",
										class: "grows unitheight",
										value: LOGINSTATE.email || "",
										hint: STR.EMAIL,
										htmlid: "login",
										maxlength: 64,
										onchange: (value) => {
											LOGINSTATE.email = value.trim();
										}
									}),
									m(InputWidget, {
										containerClass: "w-100",
										class: "grows unitheight",
										hint: STR.PASSWORD,
										htmlid: "password",
										maxlength: 64,
										type: "password",
										value: LOGINSTATE.password || "",
										onchange: (value) => {
											LOGINSTATE.password = value.trim();
										}
									}),
									m("h4", [
										STR.TOC1,
										m("a", {
											href: STR.LINK_TOC
										}, STR.TOC2),
									]),
									m(ButtonNew, {
										text: STR.LOGIN3,
										class: "accentbutton w-100 unitheight",
										onClick: () => isValid(LOGINSTATE)
											? auth(state)
											: Notification.add(STR.CREDENTIALS)
									}),
									...MAINSTATE.error ? [
										m(NoticeWidget, {
											class: "rednotice marg-2 w-100",
											icon: "exclamation-triangle",
											text: MAINSTATE.error,
											onClick: () => {
												delete MAINSTATE.error;
												m.redraw();
											}
										})
									] : [],
									m("h4", [
										STR.ACCOUNT1,
										m("a", {
											href: STR.LINK_SIGNUP
										}, STR.ACCOUNT5),
									]),
									m("h4", STR.ACCOUNT2),
									m("h4", [
										STR.ACCOUNT3,
										m("a", {
											href: STR.LINK_CONTACT
										}, STR.ACCOUNT4),
									]),
								]
							)
						]
				),
				m(".flexcol.grows.w-50.place-content-center.gradient.d-none-small.fadein", [
					m("img", {
						src: STR.IMAGE_PROMO
					})
				])
			])
		),
		() => {

			// if there are persisted credentials, trust them and
			// just jump to the services page. If these have been
			// tampered with, any backend API call will fail with
			// a 401 and we'll come back to this screen

			if (MAINSTATE.organization && MAINSTATE.token) {
				m.route.set(`/${MAINSTATE.organization}`);
			}
		}
	);

export default AuthScreen;
